module.exports = __webpack_public_path__ + "img/default-user.c36e65a9.png";